import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/whats-inspiring-our-work-content.tsx");
